// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"_3Aeqw___contentWidth-module__contentContainer","contentPadding":"_1SCuw___contentWidth-module__contentPadding"};